export const parsiMapRoutes = {
  'api.parsi-map.auto-complete': 'locations/search-parsi-map',
  'api.parsi-map.reverse-location': 'locations/geo-reverse?location=[lng],[lat]',
};
